import React from 'react';
import { Skeleton, Stack } from '@mui/material';
import { SkeletonListCard, SkeletonDetailRows } from '../../common/Utils/Skeleton/SkeletonComponents';

const PatientsOrderSkeleton = () => (
  <SkeletonListCard
    count={2}
    listItemSx={{ py: 5, alignItems: 'flex-start', flexDirection: 'column', gap: 2 }}
    renderItem={() => (
      <>
        <Stack direction="column" spacing={3} sx={{ width: '100%' }}>
          <Stack direction="row" spacing={2} sx={{ alignItems: 'center', justifyContent: 'space-between' }}>
            <Skeleton variant="text" width={100} height={32} />
            <Skeleton variant="rounded" width={80} height={30} />
          </Stack>
          <Skeleton variant="rounded" width={110} height={24} />
        </Stack>
        <Stack direction={{ xs: 'column', sm: 'row' }} sx={{ justifyContent: 'space-between', width: '100%' }}>
          <Stack spacing={1} sx={{ mb: { xs: 2, sm: 0 } }}>
            <SkeletonDetailRows widths={[180, 220, 200, 160, 190]} />
          </Stack>
          <Stack direction="row" spacing={2} sx={{ alignItems: 'flex-start', pt: { xs: 2, sm: 0 } }}>
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="circular" width={36} height={36} />
            <Skeleton variant="circular" width={36} height={36} />
          </Stack>
        </Stack>
      </>
    )}
  />
);

export default PatientsOrderSkeleton;
